// src/pages/Moderation/ModerationQueuePage/ui/ReportsTable/ReportsTableRow.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { GetFlagsResponse } from 'redux/reducers/moderation/types';
import { base } from 'routes/ModerationRoutes';
import { decodeRestrictionValue } from 'untils/decodeRestrictions';

type Props = {
  item: any;
  flags: GetFlagsResponse | null;
};

export const ReportsTableRow: React.FC<Props> = ({ item, flags }) => {
  const report = item?.report;
  const channel = item?.channel;
  const user = item?.user;
  const message = item?.message;

  const reportId = String(report?.id ?? '');
  const restriction = report?.restriction ?? '';
  const approved = report?.approved;
  const createdAt = report?.created_at ?? message?.created_at ?? '';

  return (
    <div className="reports-table__row">
      <div className="reports-table__cell reports-table__cell--id">#{reportId}</div>

      <div className="reports-table__cell reports-table__cell--restricted">
        {approved ? '❌' : approved === null ? '⚠️' : '✅'}
      </div>

      <div className="reports-table__cell reports-table__cell--restriction">
        {flags && decodeRestrictionValue(restriction, flags.data)}
      </div>

      <div className="reports-table__cell reports-table__cell--channel">
        <div className="reports-table__main">{channel?.title ?? '—'}</div>
        <div className="reports-table__sub">
          {channel?.username ? `@${channel.username}` : channel?.id ? `id:${channel.id}` : ''}
        </div>
      </div>

      <div className="reports-table__cell reports-table__cell--user">
        <div className="reports-table__main">{user?.name ?? '—'}</div>
        <div className="reports-table__sub">
          {user?.username ? `@${user.username}` : user?.id ? `id:${user.id}` : ''}
        </div>
      </div>

      <div className="reports-table__cell reports-table__cell--message">
        <div className="reports-table__main">{message?.message || '(no text)'}</div>
        <div className="reports-table__sub">{message?.id ? `msg:${message.id}` : ''}</div>
      </div>

      <div className="reports-table__cell reports-table__cell--created">{createdAt || '—'}</div>

      <div className="reports-table__cell reports-table__cell--actions">
        <Link className="reports-table__open" to={`${base}/details-queue/${reportId}`}>
          Open
        </Link>
      </div>
    </div>
  );
};
